<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'RequestsControl',
  props: {
    loadNewPage: {
      type: Number,
      required: true,
    },
    channels: {
      type: Array,
      required: true,
    },
    requestTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      requestType: '',
      channel: '',
      bookingDetailId: '',
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requestStatus.requests,
      filter: state => state.requestStatus.filter,
    }),
  },
  methods: {
    ...mapActions({
      resetRequestsPaginationIndex: 'requestStatus/resetRequestsPaginationIndex',
      setRequestsPaginationIndex: 'requestStatus/setRequestsPaginationIndex',
      getRequests: 'requestStatus/getRequests',

    }),
    updateRequestFilter(pagIndex, fromQuery) {
      if (fromQuery) {
        this.getRequests(
          {
            page: this.$route.query.page ? this.$route.query.page : 1,
            limit: 200,
            xmlChannelId: this.$route.query.xmlChannelId ? this.$route.query.xmlChannelId : '',
            bookingDetailId: this.$route.query.bookingDetailId ? this.$route.query.bookingDetailId : '',
            requestType: this.$route.query.requestType ? this.$route.query.requestType : '',
          },
        );
      } else {
        const searchParams = {
          page: pagIndex,
          limit: 200,
          xmlChannelId: this.channel ? this.channel.id : '',
          bookingDetailId: this.bookingDetailId ? this.bookingDetailId : '',
          requestType: this.requestType ? this.requestType : '',
        };
        this.getRequests(searchParams);
      }
    },
    searchButtonClick() {
      this.updateRequestFilter(1, false);
      this.resetRequestsPaginationIndex();
    },
    setBookingDetailId() {
      this.bookingDetailId = this.$route.query.bookingDetailId ? this.$route.query.bookingDetailId : '';
    },
  },
  mounted() {
    if (Object.keys(this.$route.query).length !== 0) {
      if (this.$route.query.page !== undefined) {
        this.setRequestsPaginationIndex(parseInt(this.$route.query.page, 0));
      }
      this.setBookingDetailId();
      this.updateRequestFilter(0, true);
    }
  },
  watch: {
    loadNewPage() {
      this.updateRequestFilter(this.filter.paginationIndex, false);
    },
    channels() {
      if (this.$route.query.xmlChannelId) {
        this.channel =
          this.channels
            .find(obj => obj.id === parseInt(this.$route.query.xmlChannelId, 0));
      }
    },
    requestTypes() {
      if (this.$route.query.requestType) {
        this.requestType =
          this.requestTypes
            .find(obj => obj.type === this.$route.query.requestType.toLowerCase()).type;
      }
    },
  },
};
</script>

<template>
  <v-container class="ma-0 fluid">
    <v-layout row align-center>
      <v-flex md2>
        <v-autocomplete
          v-model="channel"
          :items="this.channels"
          label="Channel"
          item-text="webservice"
          class="ma-2"
          return-object
          clearable
          chips
          hide-selected
          hide-details
          deletable-chips
        />
      </v-flex>
      <v-flex md6>
        <v-radio-group
          v-model="requestType"
          class="justify-center"
          row
          clearable
        >
          <v-radio
            label="All"
            value=""
          ></v-radio>
          <v-radio
            v-for="n in this.requestTypes"
            :key="n.id"
            :label="n.label"
            :value="n.type"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex md2>
        <v-text-field
          v-model="bookingDetailId"
          :height="42"
          value="test"
          label="Booking Detail ID"
          class="ma-2"
          clearable
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex md2>
        <v-btn
          @click="searchButtonClick"
          :disabled="requests.loading"
          class="right align-center"
          max-width="1"
          primary
        >
          Search
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/requests/RequestsControl.vue